module.exports = __webpack_public_path__ + "static/media/menu-experience.704c7b5e.png";